var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-room-manager"},[(_vm.iframeUrl)?_c('iframe',{staticStyle:{"z-index":"10"},attrs:{"src":_vm.iframeUrl,"width":"100%","frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }